import { get, writable } from 'svelte/store';
import { VisitService } from '../../services/visit.service';
import { formatDateOnlyISO } from '../../utils/date-utils';
export const loading = writable(false);
export const filter = writable({ criteria: { refDate: formatDateOnlyISO(new Date()), showCompleted: 0 } });
export const records = writable([]);
export const editingNote = writable(0);
export async function initList() {
    let refDate = formatDateOnlyISO(new Date());
    filter.set({ criteria: { refDate: refDate, showCompleted: 0 }, params: null, sorting: "" });
    await load();
}
export async function load() {
    editingNote.set(0);
    loading.set(true);
    try {
        let _filter = get(filter);
        let _resp = await VisitService.getVisitItems(_filter);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export function onDateFilterChanged(evt) {
    let date = evt.detail;
    if (!date)
        return;
    let _filter = get(filter);
    filter.set(Object.assign(Object.assign({}, _filter), { criteria: Object.assign(Object.assign({}, _filter.criteria), { refDate: date }) }));
    load();
}
export async function markItemViewed(item) {
    await VisitService.markVisitItemViewed(item);
    await load();
}
export async function markItemLocked(item) {
    await VisitService.markVisitItemLocked(item);
    await load();
}
export async function markItemUnviewed(item) {
    await VisitService.markVisitItemUnviewed(item);
    await load();
}
export async function markItemUnprinted(item) {
    await VisitService.markVisitItemUnprinted(item);
    await load();
}
export function startEditingNote(item) {
    if (!item)
        return;
    editingNote.set(item.slaughterItemOid);
}
export async function saveNote(item) {
    if (!item) {
        await load();
        return;
    }
    await VisitService.saveVisitItemNotes(item);
    editingNote.set(0);
    await load();
}
